/**
* JumpScroll
*/

/**
 * função para quando tiver um #link fazer o scrollJump
 */
(function hashHredJump(){
  if(location.hash){
    scrollJump(location.hash);
  }
}());

/**
 * função para animate da pagina
 * @param   {[type]} element
 * @returns {[type]}         [description]
 */
function scrollJump(element){
  let anchor = element.replace('#',''),
      $windowPosition = $(window).scrollTop(),
      $anchorPosition = $(`a[name=${anchor}]`).offset().top,
      finalPosition = ($anchorPosition + $windowPosition) - 100;

  $('html,body').animate({
    scrollTop: finalPosition
  }, 700, 'swing')
}

/**
 * Evento de click no menu main
 * @type {[type]}
 */
$('.navbar-main a.scroll').on('click', function(e){
  e.preventDefault();
  let $anchorLink = $(`a[name=${$(this).attr('href').replace('#','')}]`);

  if($anchorLink.length == 0){
    location.href = `/${$(this).attr('href')}`;
  }else{
    /**
     * Executa função para animate da pagina
     */
    scrollJump($(this).attr('href'));
    $('.navbar-toggle').trigger('click');
  }
})

/**
 * Click na animação do Hero Section na Home
 * @type {[type]}
 */
$('.arrow-down').on('click', function(e){
  e.preventDefault();
  /**
   * Executa função para animate da pagina
   */
  scrollJump($(this).attr('href'));
});



//////////////////
// WEBPACK FOOTER
// ./src/javascripts/jump_scroll.js
// module id = 23
// module chunks = 0